storefrontApp.service('URLService', ['$location', function ($location) {

    return {
        getQueryString: function (field, url) {
            var href = url ? url : $location.$$absUrl;
            var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            var string = reg.exec(href);
            return string ? string[1] : null;
        }
    }

}]);
